import { render, staticRenderFns } from "./Mine.vue?vue&type=template&id=8ebf0baa&"
import script from "./Mine.vue?vue&type=script&lang=js&"
export * from "./Mine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ebf0baa')) {
      api.createRecord('8ebf0baa', component.options)
    } else {
      api.reload('8ebf0baa', component.options)
    }
    module.hot.accept("./Mine.vue?vue&type=template&id=8ebf0baa&", function () {
      api.rerender('8ebf0baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/forum/Mine.vue"
export default component.exports